import moment from 'moment';
import { CustomNotification } from '../../../../../v2-components/Notification';
import { Notification } from '../../../../../v2-components/Notification/constant';

export const temporalClosingTime = (values) => {
    const openingMoment = moment(values.begin, 'HH:mm:ss');
    const closingMoment = moment(values.end, 'HH:mm:ss');

    const result = closingMoment.isAfter(openingMoment);

    if (!result) {
        CustomNotification({
            type: Notification.type.error,
            message: Notification.message.error,
            description: "Asegúrese que el horario de Inicio sea menor al de Fin",
        });
        return false;
    }

    return true;
};
